<template>
  <div class="md:mx-auto md:w-1/2 mx-6 container">
    <h1 class="text-2xl my-4">Contact</h1>
    <p>Feel free to each out if you notice anything amiss.</p>
    <address my-2><a href="mailto:admin@crowd-scout.com">admin@crowd-scout.com</a></address>
  </div>
</template>